// Only enable debug info in development
export const compileProvider = $compileProvider => {
  'ngInject';
  const isEnabled = /dev|test/.test(process.env.NODE_ENV);
  $compileProvider.debugInfoEnabled(isEnabled);
};



// WEBPACK FOOTER //
// ./src/providers/compileProvider.js